import React from 'react';
import { CustomSelect } from 'web-library';
import { useTranslation } from 'react-i18next';
import { DropDownItem } from '../../../../hooks/dropdown';

export const BlacklistingExamType: DropDownItem[] = [
  { key: 'k-NON_NATIONAL', value: 'NON_NATIONAL', children: 'Non-national' },
  { key: 'k-NATIONAL', value: 'NATIONAL', children: 'National' },
];

export interface ExamTypeSingleSelectProps {
  /**
   * to handle select on change event
   */
  onChange?: (event: string) => void;
  /**
   * set default selected options
   */
  defaultValue?: string;
  className?: string;
}

const ExamTypeSingleSelect: React.FC<ExamTypeSingleSelectProps> = (
  props: ExamTypeSingleSelectProps
) => {
  const { onChange = () => null, defaultValue, className } = props;
  const { t } = useTranslation();

  return (
    <CustomSelect
      placeholder={t('admin->>CandidateBlacklist.SelectExamType')}
      value={defaultValue}
      displayEmpty
      label={t('admin->>CandidateBlacklist.ExamType')}
      labelId="inputSelectLabel-examType"
      id="inputSelect-examType"
      onChange={(e) => onChange(e.target.value as string)}
      menuItems={BlacklistingExamType}
      variant="filled"
      className={className}
    />
  );
};
export default ExamTypeSingleSelect;
